import { render, staticRenderFns } from "./offline-experience.vue?vue&type=template&id=85edf5ce&scoped=true"
import script from "./offline-experience.vue?vue&type=script&lang=js"
export * from "./offline-experience.vue?vue&type=script&lang=js"
import style0 from "./offline-experience.vue?vue&type=style&index=0&id=85edf5ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85edf5ce",
  null
  
)

export default component.exports